'use strict';

module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/lib/utils/is-browser.js
// module id = 334
// module chunks = 0